import NotificationPage from "../components/notifications/main";

const Notifications = () => {
  return <NotificationPage />;
};

export default Notifications;
